import * as React from "react";
import TextField from "@mui/material/TextField";
import { InputAdornment, InputLabel, Tooltip } from "@mui/material";
import "./components.css";
import moment from "moment";
import {
  LocalizationProvider,
  DesktopDatePicker,
  MobileDatePicker,
} from "@mui/x-date-pickers";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import dayjs, { Dayjs } from 'dayjs';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { useTranslation } from "react-i18next";
import { useMediaQuery } from '@mui/material';

export default function DatePickerComponent(props) {
  const { t } = useTranslation();
  const { value, required, onChange, label, view, name, disabled } = props;
  const isTouchDevice = useMediaQuery('(pointer: coarse)');
  const twentyOneYearsAgo = dayjs().subtract(21, 'year');
  const defaultCalendarMonth = name === "DateOfBirth" && !value ? twentyOneYearsAgo : undefined;

  const handleChange = (newValue) => {
    let formattedValue = newValue
      ? view === "year"
        ? moment(new Date(newValue.year(), 0, 1)).format("YYYY")
        : moment(new Date(newValue)).format("YYYY-MM-DD")
      : "";
    
    onChange({ target: { value: formattedValue } });
  };

  const onKeyDown = (e) => e.preventDefault();
  const handlePaste = (e) => e.preventDefault();
  const handleCopy = (e) => e.preventDefault();
  const handleCut = (e) => e.preventDefault();

  return (
    <div className="flexAlignColumnClassName datePickerDiv" onClick={(e) => e.preventDefault()}>
      <InputLabel
        htmlFor="outlined-adornment-amount"
        required={required}
        className="labelClassName"
      >
        {t(label)}
      </InputLabel>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        {isTouchDevice ? (
          <MobileDatePicker
            inputFormat={view === "year" ? "YYYY" : "MM/DD/YYYY"}
            views={view === "year" ? ['year'] : ['year', 'month', 'day']}
            value={value === "" ? null : dayjs(value)}
            onChange={handleChange}
            disableMaskedInput={true}
            className="menuItemOptionTag textFieldInputComponent"
            maxDate={name === "DateOfBirth" ? twentyOneYearsAgo : undefined}
            defaultCalendarMonth={defaultCalendarMonth}
            disabled={disabled}
            DialogProps={{
              onClose: () => {
                document.activeElement.blur();
              },
              sx: {
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0
              },
            }}
            InputProps={{
              classes: {
                root: "outlinedInputRoot",
                focused: "outlinedInputFocused",
                notchedOutline: "outlinedInput",
                input: value && "ml"
              },
              endAdornment: (
                <InputAdornment>
                  <CalendarMonthIcon />
                </InputAdornment>
              ),
            }}
            showToolbar={false} // Disables the toolbar, removing the pencil icon
            renderInput={(params) => (
              <TextField
                {...params}
                data-testid="textfield"
                placeholder={view === "year" ? "YYYY" : "MM/DD/YYYY"}
                onKeyDown={onKeyDown}
                onDrop={(e) => e.preventDefault()}
                inputProps={{
                  ...params.inputProps,
                  autoComplete: "off",
                  onPaste: handlePaste,
                  onCopy: handleCopy,
                  onCut: handleCut,
                  readOnly: true,
                  inputMode: "none",
                }}
              />
            )}
          />
        ) : (
          <DesktopDatePicker
            inputFormat={view === "year" ? "YYYY" : "MM/DD/YYYY"}
            views={view === "year" ? ['year'] : ['year', 'month', 'day']}
            value={value === "" ? null : dayjs(value)}
            onChange={handleChange}
            disableMaskedInput={true}
            className="menuItemOptionTag textFieldInputComponent"
            maxDate={name === "DateOfBirth" ? twentyOneYearsAgo : undefined}
            defaultCalendarMonth={defaultCalendarMonth}
            disabled={disabled}
            InputProps={{
              classes: {
                root: "outlinedInputRoot",
                focused: "outlinedInputFocused",
                notchedOutline: "outlinedInput",
                input: value && "ml"
              },
              endAdornment: (
                <InputAdornment>
                  <CalendarMonthIcon />
                </InputAdornment>
              ),
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                data-testid="textfield"
                onKeyDown={onKeyDown}
                placeholder={view === "year" ? "YYYY" : "MM/DD/YYYY"}
                onDrop={(e) => e.preventDefault()}
                inputProps={{
                  ...params.inputProps,
                  autoComplete: "off",
                  onPaste: handlePaste,
                  onCopy: handleCopy,
                  onCut: handleCut,
                  readOnly: true,
                  inputMode: "none",
                }}
              />
            )}
          />
        )}
      </LocalizationProvider>
      <div className="datePickerIconsDiv">
        {value && !disabled && (
          <Tooltip title="Clear date" data-testid="tooltip">
            <HighlightOffIcon
              data-testid="icon"
              onClick={() => handleChange("")}
              style={{ cursor: "pointer" }}
            />
          </Tooltip>
        )}
      </div>
    </div>
  );
}
